<!--首页-->
<template>
  <div>
    <div class="box">
      <loginDialog :show="loginShow"></loginDialog>
      <!-- 头部 -->
      <!-- <div class='header flex-between'>
                <div class='header-left flex-between'>
                    <img class='header-user-img' :src='header.logo'>
                    <div class='header-user-text'>{{header.name}}</div>
                </div>
                <div class='header-right flex-center'>
                    <a class='header-right-box flex-between' @click='onSearch'>
                        <img class='search-icon' src='https://static.dierqudao.com/images/icon_search.png'>
                        <input class='search-input' placeholder='搜索你想找的宝贝!' readonly></input>
                    </a>
                </div>
      </div>-->

      <!-- 导航栏 -->
      <!-- <div class="goods-type">
                <van-tabs sticky title-active-color="#FD2840">
                    <van-tab v-for="item in pageList" v-bind:title="item.name" :key="item.id">
                    </van-tab>
                </van-tabs>
      </div>-->

      <div class="header-box">
        <!-- <img style="width:100%" src="https://static.dierqudao.com/images/vfd/new-index-back.png" alt="" srcset=""> -->
        <van-sticky>
          <div class="header-search-box">
            <van-search
              v-model="value"
              shape="round"
              background="rgba(250,74,85,1)"
              placeholder="请输入搜索关键词"
              @click='onSearch'
            />
          </div>
        </van-sticky>
      </div>

      <div class v-for="(item, index) in contentList" style="margin-top:10px">
        <slidePics v-if="item.type == 'slidePics'" :content="item.content" :top="top"></slidePics>
        <navButton v-if="item.type == 'navButton'" :content="item.content"></navButton>
        <notice v-if="item.type == 'notice'" :content="item.content"></notice>
        <pic v-if="item.type == 'pic'" :content="item.content"></pic>
        <pics v-if="item.type == 'pics'" :content="item.content"></pics>

        <goodsList0 v-if="item.type == 'goodsList0'" :content="item.content" :title="item.title"></goodsList0>
        <goodsList1 v-if="item.type == 'goodsList1'" :content="item.content" :title="item.title"></goodsList1>
        <goodsList2 v-if="item.type == 'goodsList2'" :content="item.content"></goodsList2>
        <goodsList3 v-if="item.type == 'goodsList3'" :content="item.content"></goodsList3>
        <goodsTabs v-if="item.type == 'goodsTabs1'" :content="item.content"></goodsTabs>

      </div>
      <div style="height:1rem"></div>
      <!-- <CopyRight></CopyRight> -->
      <!-- <p style="text-align: center"><a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" style="color: #666;">苏ICP备16038241号</a></p> -->
      <!-- 底部导航 -->
      <TabBar :show-tab-bar="true"></TabBar>
    </div>
  </div>
</template>
<style scoped>
  @import "../../assets/style/index.css";

  .header-box {
    width: 100%;
    height: 3.6rem;
    position: relative;
    background: url("https://static.dierqudao.com/images/guanghe/new-index-back.png");
    background-size: 100%;
    overflow: hidden;
    padding-top: 0.6rem;
  }

  .header-search-box {
    width: 100%;
    /* position: absolute; */
    /* top: 0.6rem; */
  }

  .goods-type {
    top: 50px;
    position: fixed;
    width: 100%;
    background: #fff;
    z-index: 10;
  }

  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #bababa;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #bababa;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #bababa;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #bababa;
  }
</style>

<script>
    import Vue from "vue";
    import TabBar from "@/components/TabBar.vue";
    import loginDialog from "@/components/LoginDialog.vue";
    import slidePics from "@/components/index/SlidePics.vue";
    import navButton from "@/components/index/NavButton.vue";
    import goodsList0 from "@/components/index/GoodsList0.vue";
    import goodsList1 from "@/components/index/GoodsList1.vue";
    import goodsList2 from "@/components/index/GoodsList2.vue";
    import goodsList3 from "@/components/index/GoodsList3.vue";
    import goodsTabs from "@/components/index/GoodsTabs.vue";
    import notice from "@/components/index/Notice.vue";
    import pic from "@/components/index/Pic.vue";
    import pics from "@/components/index/Pics.vue";

    import CopyRight from "@/components/CopyRight.vue";

    import GoodsItems from "@/components/GoodsItem3.vue";
    import {
        Row,
        Col,
        Search,
        Tab,
        Tabs,
        Swipe,
        SwipeItem,
        Lazyload,
        Field,
        Button,
        Sticky
    } from "vant";

    Vue.use(Row)
        .use(Col)
        .use(Search)
        .use(Tab)
        .use(Tabs)
        .use(Swipe)
        .use(SwipeItem)
        .use(Lazyload)
        .use(Field)
        .use(Button)
        .use(Sticky);
    export default {
        name: "Index",
        components: {
            TabBar,
            slidePics,
            navButton,
            goodsList0,
            goodsList1,
            goodsList2,
            goodsList3,
            GoodsItems,
            loginDialog,
            CopyRight,
            pic,
            notice,
            goodsTabs,
            pics
        },
        data: function () {
            return {
                loginShow: false,
                pageId: 2,
                contentList: [],
                pageList: [],
                share: {
                    title: "-",
                    path: "-",
                    imageUrl: ""
                },
                header: {},
                top: "90px",
                value: ''
            };
        },
        filter: {},
        mounted() {
            document.title = "首页";
            this.loadList();
            this.fetch();
            let business_id = this.$route.query.business_id
            if(business_id) {
                localStorage.setItem('_business_id', business_id)
            }
        },
        destroyed() {
        },
        methods: {
            loadList() {
                let that = this;
                this.$api.get(
                    "/api/index/contentList",
                    {page_id: that.pageId},
                    res => {
                        // console.log(res)

                        that.contentList = res.data;
                    }
                );
            },

            fetch() {
                let that = this;
                this.$api.get("/api/index/indexData", {page_id: that.pageId}, res => {
                    // console.log(res);
                    that.pageList = res.data.pageList;
                    that.header = res.data.header;
                    that.share = res.data.share;

                    that.wxShare(
                        res.data.share.title,
                        res.data.share.desc,
                        res.data.share.url,
                        res.data.share.pic_url
                    );
                });
            },

            // 搜索
            onSearch() {
              rbLink(
                {
                  name: "GoodsSearch",
                  query: {}
                },
                "push"
              );
                // this.$router.push("/search");
                // console.log('onSearch')
            }
        }
    };
</script>



// WEBPACK FOOTER //
// GoodsIndex.vue?1c5d71e6